/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import { useState } from "react";
import { Button } from "@mui/material";
import { ReactComponent as MenuIcon } from "cms/assets/icons/menu.svg";
import { ReactComponent as XIcon } from "cms/assets/icons/x.svg";
import { useScrollTargets } from "./use-scroll-targets";
import { MobileMenu } from "./mobile-menu";
import { HeaderLogo } from "./header-logo";

const headerTargetTitles = ["About us", "Adjudication", "Additional evidence", "Contact"];

const Header = () => {

    const [showMobileMenu, setShowMobileMenu] = useState(false);
    const scrollTargets = useScrollTargets();
    const headerNavLinks = scrollTargets?.filter((scrollTarget) =>
        headerTargetTitles.includes(scrollTarget.title)
    );

    const toggleMobile = () => {
        setShowMobileMenu(!showMobileMenu);
    };

    const scrollToSection = (id) => {
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({ behavior: "smooth" });
            setShowMobileMenu(false);
        }
    };

    return (
        <div className='header'>
            <div className='header-content'>
                <HeaderLogo />
                <div className='header-links'>
                    {headerNavLinks.map((navLink, index) => {
                        const isLastItem = index === headerNavLinks?.length - 1;
                        return (
                            <div className="header-link-item" key={`${navLink.title}_${index}`}>
                                <Button
                                    onClick={() => scrollToSection(navLink.id)}
                                >
                                    {navLink.title}
                                </Button>
                                {!isLastItem && <span className='header-link-separator' />}
                            </div>
                        );
                    })}
                </div>

                <div className='header-mobile-toggle'>
                    <button onClick={toggleMobile}>
                        {showMobileMenu && <XIcon alt='close-icon' />}
                        {!showMobileMenu && <MenuIcon alt='menu-icon' />}
                    </button>
                </div>
            </div>

            <MobileMenu
                headerNavLinks={headerNavLinks}
                scrollToSection={scrollToSection}
                show={showMobileMenu}
            />
        </div>
    );
};

export { Header };
